import { render } from "./PreviewProviderModal.vue?vue&type=template&id=bb029e54"
import script from "./PreviewProviderModal.vue?vue&type=script&lang=js"
export * from "./PreviewProviderModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "bb029e54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb029e54', script)) {
    api.reload('bb029e54', script)
  }
  
  module.hot.accept("./PreviewProviderModal.vue?vue&type=template&id=bb029e54", () => {
    api.rerender('bb029e54', render)
  })

}

script.__file = "resources/js/Pages/User/Partials/PreviewProviderModal.vue"

export default script